(function($) {
    $(document).ready(function() {
        // Only run in admin/editor
        if (typeof wp !== 'undefined' && wp.data && wp.data.select) {
            // Handle clicks on editor version
            $(document).on('click', '.image-btn-link--editor', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Show a gentle notification
                if (wp.data && wp.data.dispatch) {
                    const href = $(this).data('href');
                    const target = $(this).data('target') || '_self';
                    const message = href === '#' ? 
                        'No link set. Edit in block settings.' : 
                        `Link points to: ${href} (opens in ${target})`;
                    
                    wp.data.dispatch('core/notices').createNotice(
                        'info',
                        message,
                        {
                            isDismissible: true,
                            type: 'snackbar',
                            duration: 3000
                        }
                    );
                }
                
                return false;
            });
        }
    });
})(jQuery);